// extracted by mini-css-extract-plugin
export var navbarSubLink = "H_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "H_t1 d_f0 d_dB";
export var subPageLink = "H_gf d_gf";
export var burger = "H_vK";
export var sublinkSize = "H_vL";
export var linkSize = "H_vM";
export var Link = "H_rX r_rX r_rk r_rF";